/* Mikaya — FAQ accordion. One open at a time per [data-mk-faq] group.
   Animates max-height; reduced-motion handled by CSS (transition removed). */
(function () {
  function init() {
    document.querySelectorAll('[data-mk-faq]').forEach(function (group) {
      if (group.dataset.mkFaqReady) return;
      group.dataset.mkFaqReady = '1';
      group.addEventListener('click', function (e) {
        var q = e.target.closest('.mk-faq__q');
        if (!q || !group.contains(q)) return;
        var item = q.closest('.mk-faq__item');
        var a = item.querySelector('.mk-faq__a');
        var isOpen = item.classList.contains('is-open');
        group.querySelectorAll('.mk-faq__item.is-open').forEach(function (o) {
          o.classList.remove('is-open');
          var oq = o.querySelector('.mk-faq__q');
          if (oq) oq.setAttribute('aria-expanded', 'false');
          var oa = o.querySelector('.mk-faq__a');
          if (oa) oa.style.maxHeight = null;
        });
        if (!isOpen) {
          item.classList.add('is-open');
          q.setAttribute('aria-expanded', 'true');
          if (a) a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('resize', function () {
    document.querySelectorAll('.mk-faq__item.is-open .mk-faq__a').forEach(function (a) {
      a.style.maxHeight = a.scrollHeight + 'px';
    });
  });
})();
